import Vue from 'vue'

function isLoggedIn() {
  return !!localStorage.getItem(Vue.prototype.$auth.options.tokenDefaultKey)
}

export {
  isLoggedIn,
}
